<template>
  <div>
    <!-- <Cabecera></Cabecera> -->
    <main role="main">
       <!-- <StepNumbers></StepNumbers> -->
       <div class="c-steps-numbers">
        <div class="container">
          <div class="c-steps-numbers__item success"><span>1</span>
            <p>Información y<br>antecedentes legales</p>
          </div>
          <div class="c-steps-numbers__item success"><span>2</span>
            <p>Antecedentes<br>financieros</p>
          </div>
          <div class="c-steps-numbers__item active"><span>3</span>
            <p>Patrocinios</p>
          </div>
          <div class="c-steps-numbers__item"><span>4</span>
            <p>Participación</p>
          </div>
          <div class="c-steps-numbers__item"><span>5</span>
            <p>Declaraciones<br>y compromisos</p>
          </div>
        </div>
      </div>
    <div class="c-form-steps">
        <!-- <div class="requestNumber">
          <p>SOLICITUD N° {{globalRequestNumber}}</p>
        </div> -->
        <div class="c-form-steps__sections" data-step="03">
          <div class="container">
            <div class="c-form-steps__content step-data">
              <div class="row">
                <div class="col-md-12 col-lg-5 offset-lg-2">
                  <h2>Patrocinante 1</h2>
                  <p>Los patrocinantes serán contactados por la CChC para dar su conformidad, por lo cual es necesario tener sus datos actualizados.
                  <br><br><b>En el caso de las empresas, quien patrocina es la persona representante legal o representante ante la Cámara de la empresa.</b></p>
                  <form action="#" id="step05_1">
                    <div class="input"  ref="rut">
                      <label>RUT del Patrocinante 1</label>
                      <input tabindex="1" type="text" name="rutparticipante_st05" v-model="rutParticipante" ref="rutParticipante" @focus="focus($refs.rut)" 
                      @blur="blur([$refs.rut, $refs.rutParticipante.value]), 
                      validateRutExist(rutParticipante, $refs.nombre)" @keyup="rutPatrocinanteValidation($refs.rutParticipante.value)"
                      :disabled="!this.corregir"
                      >
                      <div class="small-text">Sin puntos y con guión (11111111-1)</div><span data-modal="step03_1" data-type="modal" @click="show">?</span>
                      <div id="rutst02-error" class="formerror" v-if="rutPatrocinanteIsValid === false">Ingrese un rut Válido</div>
                    </div>
                    <div class="input" ref="nombre">
                      <label>Nombre del Patrocinante 1</label>
                      <input tabindex="2" 
                      type="text" 
                      maxlength="100" 
                      name="nombreparticipante_st05" 
                      v-model="nombreParticipante" 
                      ref="nombreParticipante" @focus="focus($refs.nombre)" @blur="blur([$refs.nombre, $refs.nombreParticipante.value])"
                      :disabled="!this.corregir"
                      >
                    </div>
                    <div class="input active" ref="telefono">
                      <label>Teléfono </label>
                      <input tabindex="3" type="text" name="telefonoparticipante_st05" v-model="telefonoParticipante" ref="telefonoParticipante" @focus="focus($refs.telefono)" @blur="blur([$refs.telefono, $refs.telefonoParticipante.value])" @keyup="telPatrocinanteValidation($refs.telefonoParticipante.value)"
                      :disabled="!this.corregir"
                      >
                      <div class="small-text">Use el formato +56 0 0000 0000</div>
                      <div id="rutst02-error" class="formerror" v-if="telPatrocinanteIsValid === false">Ingrese un teléfono Válido</div>
                    </div>
                    <div class="input u-mb0" ref="email">
                      <label>Email</label>
                      <input tabindex="4" type="text" name="emailparticipante_st05" v-model="emailParticipante" ref="emailParticipante" @focus="focus($refs.email)" @blur="blur([$refs.email, $refs.emailParticipante.value])" @keyup="emailPatrocinanteValidation($refs.emailParticipante.value)"
                      :disabled="!this.corregir"
                      @keydown.tab="collapsePat([$refs.collapse, $refs.collapseMin])"
                      >
                      <div id="rutst02-error" class="formerror" v-if="emailPatrocinanteIsValid === false">Ingrese un email Válido</div>
                    </div>
                  </form>
                </div>
                <div class="col-md-4 col-lg-3 offset-lg-1">
                  <div class="c-form-steps__side desktop">
                    <h3>¿DUDAS SOBRE EL PROCESO?</h3>
                    <ul>
                      <li><a href="https://www.cchc.cl/postulante/como-postular" target="_blank">Cómo postular<span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.6653 2.33206L7.66532 10.3321L6.04907 8.71582L14.0491 0.71582L15.6653 2.33206Z" fill="#00B29A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.14286 2.28571L13.7143 2.28571V6.85714H16V0H9.14286V2.28571ZM4.57143 2.28571V0H0V16H16V11.4286H13.7143V13.7143H2.28571V2.28571L4.57143 2.28571Z" fill="#00B29A"/></svg></span></a></li>
                      <li><a href="https://www.cchc.cl/postulante/contacto" target="_blank">Contacta al ejecutivo <br>según tu región<span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.6653 2.33206L7.66532 10.3321L6.04907 8.71582L14.0491 0.71582L15.6653 2.33206Z" fill="#00B29A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.14286 2.28571L13.7143 2.28571V6.85714H16V0H9.14286V2.28571ZM4.57143 2.28571V0H0V16H16V11.4286H13.7143V13.7143H2.28571V2.28571L4.57143 2.28571Z" fill="#00B29A"/></svg></span></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="c-form-drag whitebg small" ref="collapse" tabindex="5">
            <div class="container"><a class="section-minimizar" ref="collapseMin" @click="collapseClickStep3([$refs.collapse, $refs.collapseMin])">{{collapse}}</a>
              <span tabindex="7" @keydown.tab="collapsePat([$refs.collapse, $refs.collapseMin])"></span>
                <div class="row">
                  <div class="col-md-12 col-lg-6 offset-lg-2">
                    <form action="#" id="step05_2">
                      <h2 tabindex="6">Patrocinante 2</h2>
                      <div class="input" ref="rut2">
                        <label>RUT del Patrocinante 2</label>
                        <input tabindex="8" type="text" name="rutparticipante02_st05" v-model="rutParticipante2" ref="rutParticipante2" @focus="focus($refs.rut2)"
                         @blur="blur([$refs.rut2, $refs.rutParticipante2.value]), 
                        validateRutExist2(rutParticipante2, $refs.nombre2)" @keyup="rutPatrocinante2Validation($refs.rutParticipante2.value)"
                        :disabled="!this.corregir" 
                         >
                        <div class="small-text">Sin puntos y con guión (11111111-1)</div><span data-modal="step03_1" data-type="modal" @click="show">?</span>
                        <div id="rutst02-error" class="formerror" v-if="rutPatrocinante2IsValid === false">Ingrese un rut Válido </div>
                      </div>
                      <div class="input" ref="nombre2">
                        <label>Nombre del Patrocinante 2</label>
                        <input tabindex="9" type="text" maxlength="100" 
                        name="nombreparticipante02_st05" 
                        v-model="nombreParticipante2" 
                        ref="nombreParticipante2"
                         @focus="focus($refs.nombre2)" @blur="blur([$refs.nombre2, $refs.nombreParticipante2.value])"
                        :disabled="!this.corregir"
                        >
                      </div>
                      <div class="input active" ref="telefono2">
                        <label>Teléfono </label>
                        <input tabindex="10" type="text" 
                        name="telefonoparticipante02_st05" 
                        v-model="telefonoParticipante2" 
                        ref="telefonoParticipante2"
                         @focus="focus($refs.telefono2)" 
                         @blur="blur([$refs.telefono2, $refs.telefonoParticipante2.value])"
                          @keyup="telPatrocinante2Validation($refs.telefonoParticipante2.value)"
                        :disabled="!this.corregir"
                        >
                        <div class="small-text">Use el formato +56 0 0000 0000</div>
                        <div id="rutst02-error" class="formerror" v-if="telPatrocinante2IsValid === false">Ingrese un teléfono Válido</div>
                      </div>
                      <div class="input u-mb0" ref="email2">
                        <label>Email</label>
                        <input tabindex="11" type="text" 
                        name="emailparticipante02_st05" 
                        v-model="emailParticipante2" 
                        ref="emailParticipante2" @focus="focus($refs.email2)" 
                        @blur="blur([$refs.email2, $refs.emailParticipante2.value])" @keyup="emailPatrocinante2Validation($refs.emailParticipante2.value)" 
                        :disabled="!this.corregir"
                        >
                        <div id="rutst02-error" class="formerror" v-if="emailPatrocinante2IsValid === false">Ingrese un email Válido</div>
                      </div>
                    </form>
                  </div>
                </div>
            </div>
          </div>
          <div class="c-form-steps whitebg">
            <div class="container">
              <div class="c-form-steps__content step-data u-pt0">
                <div class="row">
                  <div class="col-md-12 col-lg-12 offset-lg-2">
                    <form action="#" id="step04_3">
                      <button class="link prev btn-blue u-mt50 u-mr30 small" type="button" 
                        @click="anterior(), scrollToTop()">
                        <i class="fa fa-angle-left"></i>Anterior</button>

                        <div v-if="!this.tieneCorreccion" style="display: inline;">
                        <button class="link btn-red u-mt50 big u-mr20" tabindex="12" type="button" id="submitStep05" @click="save">Guardar<i class="fa fa-angle-right"></i></button>
                        </div>

                        <button class="link btn-red u-mt50 big" tabindex="13" type="button" id="submitStep05"                     
                        @click="saveContinue(), scrollToTop()"
                        v-if="formLoaded == true"
                        >Continuar<i class="fa fa-angle-right"></i>
                        </button>
                        
                        <button class="link btn-red u-mt50 big" tabindex="13" type="button" id="submitStep05"                      
                        @click="saveContinue(), scrollToTop()"
                        :disabled="!formLoaded"
                        v-if="formLoaded == false"
                        >Continuar<i class="fa fa-angle-right"></i></button>

                      </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal name="help-modal-1" :height="400">
        
          <a class="close-modal-text" @click="$modal.hide('help-modal-1')">X</a>
          <h2>¿Quiénes son los patrocinadores?</h2>
          <ul>
            <li style="margin-top:10px;margin-bottom:10px;"><span style="color:white; margin-right:10px;">&diams;</span>Para el caso de las empresas, quien patrocina debe ser el Representante ante la Cámara o Representante Legal.</li>
            <li style="margin-top:10px;margin-bottom:10px;"><span style="color:white; margin-right:10px;">&diams;</span>El patrocinante NO puede tener relación con el postulante.</li>
            <li style="margin-top:10px;margin-bottom:10px;"><span style="color:white; margin-right:10px;">&diams;</span>NO puede patrocinar:</li>
          </ul>
          <p style="font-size:16px;margin-top:15px;margin-bottom:10px;">Quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.</p>
          <p style="font-size:16px;margin-top:15px;margin-bottom:10px;">Integrantes de Mesas Directivas Nacional y de Cámaras Regionales.</p>
          <p style="font-size:16px;margin-top:15px;margin-bottom:10px;">Directores Nacionales.</p>
          <p style="font-size:16px;margin-top:15px;margin-bottom:10px;">Consejeros Regionales.</p>
          <p style="font-size:16px;margin-top:15px;margin-bottom:10px;">Integrantes de las Comisiones de Socios a nivel nacional.		</p>
      </modal>
      </main>
  </div>
  
</template>

<script>
import Cabecera from './../../components/Cabecera';
import StepNumbers from './../../components/StepNumbers';
import { mapState, mapMutations, mapGetters } from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueRouter from "vue-router";
import Swal from 'sweetalert2';

export default {
  name: 'StepThree',
  components: {
    Cabecera,
    StepNumbers
  },
  data () {
      return {
        rutParticipante: '',
        rutParticipante2: '',
        nombreParticipante: '',
        nombreParticipante2: '',
        emailParticipante: '',
        emailParticipante2: '',
        telefonoParticipante: '+56',
        telefonoParticipante2: '+56',
        dataPatrocinantes: [],
        dataValidaciones: [],
        dataPatrocinantesNoValidos:[],
        grupos: {},
        estado: '',
        estado2: '',
        grupos2: {}, 
        motivo: {},
        motivo2: {},
        rutPatrocinatnes: [],
        noExiste: false,
        noExiste2: false,
        cumple: false,
        cumple2: false,
        objectData : [],
        urlBase: this.$store.state.URL,
        getStepThree: [],
        rutCompanyValidation: '',
        storeObjectStepThree: [],
        banderaActivarClases: false,
        rutNoIdentico: '',
        corregir : true,
				tieneCorreccion: false,
        formLoaded: false,
        idSocioPatrocinante1: null,
        idSocioPatrocinante2: null,
      }
    },
    methods:{
      ...mapMutations(['focus', 
                       'blur', 
                       'collapseClickStep3', 
                       'collapsePat',
                       'rutValidation', 
                       'phoneNumberValidation', 
                       'emailValidation', 
                       'saveCompletedForm', 
                       "setStepTwoValue", 
                       "setStepThreeValue" ,
                       "setStepFourValue", 
                       'rutPatrocinates',
                       'rutPatrocinanteValidation',
                       'rutPatrocinante2Validation',
                       'telPatrocinanteValidation',
                       'telPatrocinante2Validation',
                       'emailPatrocinanteValidation',
                       'emailPatrocinante2Validation',
                       'getRutGlobal',
                       'setRutIsValid',
                       'setObjetoStepThree'
                       ]),
       ...mapGetters([
                      "getterObjectData",
                      "getterRutGlobal",
                      "getterObjetoStepThree"
                      ]),                 
      /*
      savePatrocinante1() {

        if (this.rutPatrocinanteIsValid == true
            && this.telPatrocinanteIsValid == true
            && this.emailPatrocinanteIsValid == true) {
              
              if (this.estado == 'AL DIA' && this.grupos.name !== 'DIRECTORIO NACIONAL'
              && this.grupos.name !== 'MESA DIRECTIVA NACIONAL'
              && this.grupos.name !== 'MESA DIRECTIVA REGIONAL'
              && this.grupos.name !== 'CONSEJO REGIONAL'
              && this.grupos.name !== 'COMISION DE SOCIOS'
              && this.grupos.name !== 'COMISION DE SOCIOS REGIONAL') {
                this.dataPatrocinantes.push({
                    patrocinante1: {
                      rutParticipante: this.rutParticipante,
                      nombreParticipante: this.nombreParticipante,
                      emailParticipante: this.emailParticipante,
                      telefonoParticipante: this.telefonoParticipante,
                    } 
                });
                
                this.cumple = true;
                
              } else {
                alert("Patrocinante 1 no cumple los criterios establecidos. Comuníquese con el área de socios o cámara regional respectiva");
                this.dataPatrocinantesNoValidos.push({
                      patrocinante1NoCumple: {
                        nroSolicitud: this.nroSolicitudGlobal,
                        rutParticipante: this.rutParticipante,
                        nombreParticipante: this.nombreParticipante,
                        emailParticipante: this.emailParticipante,
                        telefonoParticipante: this.telefonoParticipante,
                        motivo: {
                          estado: this.estado,
                          name: this.grupos.name,
                          perId: this.grupos.perId
                        }
                      } 
                });
                this.savePartrocinanteNoValidos(this.dataPatrocinantesNoValidos);
                this.estado = '';
                this.grupos.name = '';
                this.cumple = false;
               
            }
            this.saveCompletedForm([this.dataPatrocinantes, 3]);
            

          } else {
            alert("Los datos ingresados deben ser válidos");
          }

      },

      savePatrocinante2() {
        if (this.rutPatrocinante2IsValid == true
            && this.telPatrocinante2IsValid == true
            && this.emailPatrocinante2IsValid == true) {
             
              if (this.estado2 == 'AL DIA' && this.grupos2.name !== 'DIRECTORIO NACIONAL'
              && this.grupos2.name !== 'MESA DIRECTIVA NACIONAL'
              && this.grupos2.name !== 'MESA DIRECTIVA REGIONAL'
              && this.grupos2.name !== 'CONSEJO REGIONAL'
              && this.grupos2.name !== 'COMISION DE SOCIOS'
              && this.grupos2.name !== 'COMISION DE SOCIOS REGIONAL') {
                this.dataPatrocinantes.push({
                    patrocinante2: {
                      rutParticipante: this.rutParticipante2,
                      nombreParticipante: this.nombreParticipante2,
                      emailParticipante: this.emailParticipante2,
                      telefonoParticipante: this.telefonoParticipante2,
                    } 
                });
                
                this.cumple2 = true;
                //return this.dataPatrocinantes;
              } else {
                alert("Patrocinante 2 no cumple los criterios establecidos. Comuníquese con el área de socios o cámara regional respectiva");
                this.dataPatrocinantesNoValidos.push({
                      patrocinante2NoCumple: {
                        nroSolicitud: this.nroSolicitudGlobal,
                        rutParticipante: this.rutParticipante2,
                        nombreParticipante: this.nombreParticipante2,
                        emailParticipante: this.emailParticipante2,
                        telefonoParticipante: this.telefonoParticipante2,
                        motivo: {
                          estado: this.estado2,
                          name: this.grupos2.name,
                          perId: this.grupos2.perId
                        }
                      } 
                });
                this.savePartrocinanteNoValidos(this.dataPatrocinantesNoValidos);
                this.estado2 = '';
                this.grupos2.name = '';
                this.cumple2 = false;
            }
        
            this.saveCompletedForm([this.dataPatrocinantes, 3]);
            

          } else {
            alert("Los datos ingresados deben ser válidos");
          }
      },
      */

     savePatrocinante1() {
            if (
                this.rutPatrocinanteIsValid == true
            ) {
                if (
                  //((this.estado == "AL DIA") || (this.estado == "AL DÍA") ) &&
                    this.grupos.name !== "DIRECTORIO NACIONAL" &&
                    this.grupos.name !== "MESA DIRECTIVA NACIONAL" &&
                    this.grupos.name !== "MESA DIRECTIVA REGIONAL" &&
                    //this.grupos.name !== "CONSEJO REGIONAL" &&
                    this.grupos.name !== "COMISION DE SOCIOS" &&
                    this.grupos.name !== "COMISION DE SOCIOS REGIONAL"
                ) {
                    // this.dataPatrocinantes.push({
                    //     patrocinante1: {
                    //         rutParticipante: this.rutParticipante,
                    //         nombreParticipante: this.nombreParticipante,
                    //         emailParticipante: this.emailParticipante,
                    //         telefonoParticipante: this.telefonoParticipante,
                    //     },
                    // });

                    const patrocinante1 = {
									        patrocinante1: {
                                  rutParticipante: this.rutParticipante,
                                  nombreParticipante: this.nombreParticipante,
                                  emailParticipante: this.emailParticipante,
                                  telefonoParticipante: this.telefonoParticipante,
                              },
                            }
					          this.dataPatrocinantes[0] = patrocinante1

                    this.cumple = true;
                } else {
                    // alert(
                    //     "Patrocinante 1 no cumple los criterios establecidos. Comuníquese con el área de socios o cámara regional respectiva",
                    // );
                    
                    //console.log('No Cumple');
                    this.dataPatrocinantesNoValidos.push({
                        patrocinante1NoCumple: {
                            nroSolicitud: this.nroSolicitudGlobal,
                            rutParticipante: this.rutParticipante,
                            nombreParticipante: this.nombreParticipante,
                            emailParticipante: this.emailParticipante,
                            telefonoParticipante: this.telefonoParticipante,
                            motivo: {
                                estado: this.estado,
                                name: this.grupos.name,
                                perId: this.grupos.perId,
                            },
                        },
                    });
                    //console.log("se registró un patrocinante no valido");
                    this.savePartrocinanteNoValidos(
                        this.dataPatrocinantesNoValidos
                    );
                    this.estado = "";
                    this.grupos.name = "";
                    this.cumple = false;
                    this.rutParticipante = ""
                    this.nombreParticipante = ""
                    this.emailParticipante = ""
                    this.telefonoParticipante = ""
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` });      
                }
                this.saveCompletedForm([this.dataPatrocinantes, 3]);
            } else {
                // alert("Los datos ingresados deben ser válidos");
                Swal.fire({
                      icon: 'warning',
                      title: 'Los datos ingresados deben ser válidossss',
                    })
            }
        },


        savePatrocinante2() {
            if (
                this.rutPatrocinante2IsValid == true
            ) {
                if (
                  //((this.estado2 == "AL DIA") || (this.estado2 == "AL DÍA") ) &&
                    this.grupos2.name !== "DIRECTORIO NACIONAL" &&
                    this.grupos2.name !== "MESA DIRECTIVA NACIONAL" &&
                    this.grupos2.name !== "MESA DIRECTIVA REGIONAL" &&
                    //this.grupos2.name !== "CONSEJO REGIONAL" &&
                    this.grupos2.name !== "COMISION DE SOCIOS" &&
                    this.grupos2.name !== "COMISION DE SOCIOS REGIONAL"
                ) {
                    // this.dataPatrocinantes.push({
                    //     patrocinante2: {
                    //         rutParticipante: this.rutParticipante2,
                    //         nombreParticipante: this.nombreParticipante2,
                    //         emailParticipante: this.emailParticipante2,
                    //         telefonoParticipante: this.telefonoParticipante2,
                    //     },
                    // });
                    const patrocinante2 = {
									        patrocinante2: {
                                  rutParticipante: this.rutParticipante2,
                                  nombreParticipante: this.nombreParticipante2,
                                  emailParticipante: this.emailParticipante2,
                                  telefonoParticipante: this.telefonoParticipante2,
                              },
                            }
					          this.dataPatrocinantes[1] = patrocinante2

                    this.cumple2 = true;
                    //return this.dataPatrocinantes;
                } else {
                    // alert(
                    //     "Patrocinante 2 no cumple los criterios establecidos. Comuníquese con el área de socios o cámara regional respectiva",
                    // );
                    
                    this.cumple2 = false;
                    this.dataPatrocinantesNoValidos.push({
                        patrocinante2NoCumple: {
                            nroSolicitud: this.nroSolicitudGlobal,
                            rutParticipante: this.rutParticipante2,
                            nombreParticipante: this.nombreParticipante2,
                            emailParticipante: this.emailParticipante2,
                            telefonoParticipante: this.telefonoParticipante2,
                            motivo: {
                                estado: this.estado2,
                                name: this.grupos2.name,
                                perId: this.grupos2.perId,
                            },
                        },
                    });
                    this.savePartrocinanteNoValidos(
                        this.dataPatrocinantesNoValidos
                    );
                    this.estado2 = "";
                    this.grupos2.name = "";
                    this.rutParticipante2 = ""
                    this.nombreParticipante2 = ""
                    this.emailParticipante2 = ""
                    this.telefonoParticipante2 = ""
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` })
                      }

                this.saveCompletedForm([this.dataPatrocinantes, 3]);
            } else {
                //alert("Los datos ingresados deben ser válidos");
                Swal.fire({
                      icon: 'warning',
                      title: 'Los datos ingresados deben ser válidos',
                    })
            }
        },

      saveContinueStepThree() {
        this.savePatrocinante1();
        this.savePatrocinante2();
        if (!this.tieneCorreccion){
          console.log("POSTULACION NO ESTÁ EN MODO CORRECCION");
         if ((this.cumple === true) && (this.cumple2 === true) ) {
           this.savePostStepThree();
           this.dataPatrocinantes = [];
         } else {
           this.dataPatrocinantes = [];
         }
        }
      },
      
      save() {
        Swal.fire({
            title: '¿Está seguro que desea guardar su postulación?',
            //text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: 'btn btn-danger',
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar',
          }).then((result) => {
            if (result.isConfirmed) {
              this.savePatrocinante1();
              this.savePatrocinante2();
              this.savePostStepThree();
              this.dataPatrocinantes = [];
                    
              Swal.fire(
                '¡Datos guardados satisfactoriamente!',
                '',
                'success'
              )
                    
            }
           })
      }, 

      

      // save() {
        
      //   if(this.rutNoIdentico || this.rutNoIdentico === "") {
      //     if (this.validateInputPatrocinante1() && this.validateInputPatrocinante2() && this.noExiste) {
      //         this.savePatrocinante1();
      //         this.savePatrocinante2();
      //         if ((this.cumple === true) && (this.cumple2 === true)) {
      //           Swal.fire({
      //             title: '¿Está seguro que desea guardar su postulación?',
      //             //text: "You won't be able to revert this!",
      //             icon: 'warning',
      //             showCancelButton: true,
      //             confirmButtonColor: '#28a745',
      //             cancelButtonColor: 'btn btn-danger',
      //             confirmButtonText: 'Guardar',
      //             cancelButtonText: 'Cancelar',
      //           }).then((result) => {
      //             if (result.isConfirmed) {
      //               this.savePostStepThree();
      //               this.dataPatrocinantes = [];
                    
      //               Swal.fire(
      //                 '¡Datos guardados satisfactoriamente!',
      //                 '',
      //                 'success'
      //               )
                    
      //             }
      //           })
      //         } 
            
      //       } else if(this.validateInputPatrocinante1() && this.noExiste) {
      //           this.savePatrocinante1();
              
      //         if (this.cumple === true) {
      //           Swal.fire({
      //             title: '¿Está seguro que desea guardar su postulación?',
      //             text: "¡Tenga en cuenta que solo se guardara el patrocinante 1!, debido a que los datos del patrocinante 2 estan incompletos",
      //             icon: 'warning',
      //             showCancelButton: true,
      //             confirmButtonColor: '#28a745',
      //             cancelButtonColor: 'btn btn-danger',
      //             confirmButtonText: 'Guardar',
      //             cancelButtonText: 'Cancelar',
      //           }).then((result) => {
      //             if (result.isConfirmed) {
      //               this.savePostStepThree();
      //               this.dataPatrocinantes = [];
                    
      //               Swal.fire(
      //                 '¡Datos guardados satisfactoriamente!',
      //                 '',
      //                 'success'
      //               )
                    
      //             }
      //           })
      //         } 
              
      //         } else if(this.validateInputPatrocinante2() && this.noExiste2) {
      //               this.savePatrocinante2();
      //               if (this.cumple2 === true) {
      //               Swal.fire({
      //                 title: '¿Está seguro que desea guardar su postulación?',
      //                 text: "¡Tenga en cuenta que solo se guardara el patrocinante 2!, debido a que los datos del patrocinante 1 estan incompletos",
      //                 icon: 'warning',
      //                 showCancelButton: true,
      //                 confirmButtonColor: '#28a745',
      //                 cancelButtonColor: 'btn btn-danger',
      //                 confirmButtonText: 'Guardar',
      //                 cancelButtonText: 'Cancelar',
      //                 }).then((result) => {
      //                   if (result.isConfirmed) {
      //                     this.savePostStepThree();
      //                     this.dataPatrocinantes = [];
                          
      //                     Swal.fire(
      //                       '¡Datos guardados satisfactoriamente!',
      //                       '',
      //                       'success'
      //                     )
                          
      //                   }
      //                 })
      //               } 
      //           }else {
      //             //alert("Debe completar todos los campos");
      //         Swal.fire({
      //           icon: 'warning',
      //                   title: 'Debe completar todos los campos',
      //                 })
      //           this.setStepFourValue(false);
      //       }
      //     } else {
      //         //alert('Los patrocinantes deben tener rut distinto')
      //         Swal.fire({
      //                 icon: 'warning',
      //                 title: 'Los patrocinantes deben tener rut distinto',
      //               })
      //       }

      // },

      savePartrocinanteNoValidos(data) {
        let dataJ = JSON.stringify(data);
        axios.post(this.urlBase + '/guardarNoValidos', dataJ).then((response) => {
         
        }).catch(function (error) {
          //console.log("AXIOS ERROR: ", error);
        });

      },
     /* save() {

        if (this.rutPatrocinanteIsValid == true 
            && this.rutPatrocinante2IsValid == true 
            && this.telPatrocinanteIsValid == true
            && this.telPatrocinante2IsValid == true
            && this.emailPatrocinanteIsValid == true
            && this.emailPatrocinante2IsValid == true) {
          //console.log(this.estado, this.grupos.name);
          if (this.estado == 'AL DIA' && this.grupos.name !== 'DIRECTORIO NACIONAL'
              && this.grupos.name !== 'MESA DIRECTIVA NACIONAL'
              && this.grupos.name !== 'MESA DIRECTIVA REGIONAL'
              && this.grupos.name !== 'CONSEJO REGIONAL'
              && this.grupos.name !== 'COMISION DE SOCIOS'
              && this.grupos.name !== 'COMISION DE SOCIOS REGIONAL') {
                //console.log("es digno");
            this.dataPatrocinantes.push({
            patrocinantes: {
              rutParticipante: this.rutParticipante,
              nombreParticipante: this.nombreParticipante,
              emailParticipante: this.emailParticipante,
              telefonoParticipante: this.telefonoParticipante,
              rutParticipante2: this.rutParticipante2,
              nombreParticipante2: this.nombreParticipante2,
              emailParticipante2: this.emailParticipante2,
              telefonoParticipante2: this.telefonoParticipante2,
            } 
          });
          this.noExiste =true;
        }
        else {
          alert("Patrocinante no cumple requisitos");
          this.noExiste = false;
          this.dataPatrocinantes.push({
            patrocinantes: {
              rutParticipante: this.rutParticipante,
              nombreParticipante: this.nombreParticipante,
              emailParticipante: this.emailParticipante,
              telefonoParticipante: this.telefonoParticipante,
              rutParticipante2: this.rutParticipante2,
              nombreParticipante2: this.nombreParticipante2,
              emailParticipante2: this.emailParticipante2,
              telefonoParticipante2: this.telefonoParticipante2,
              motivo: {
                estado: this.dataValidaciones.Estado,
                name: this.dataValidaciones.grupos.GRUPO,
                perId: this.dataValidaciones.grupos.PER_ID
              }
            } 
          });

        }           
      //console.log(this.dataPatrocinantes[1]);
      this.saveCompletedForm([this.dataPatrocinantes[1], 3]);
      this.savePostStepThree();
      //console.log(this.completedForm);
      } else {
        alert("Los datos tienen que ser válidos");
      }
      
      },*/

      // Se comento los ValidateRutExist y ValidateRutExist2 para mantener los originales
      /* 
      validateRutExist(rut, ref) {

        
      if (this.rutPartnerGlobal !== '' && this.rutPartnersGlobal.length == 0) {
       
        if (this.rutPartnerGlobal !== rut ) {
              axios.get(this.urlBase+'/validatePatrocinantes/' + rut).then((response) => {
                this.dataValidaciones = response.data;
              
                if (Object.keys(this.dataValidaciones).length !== 0) {
                  if (this.rutParticipante !== this.rutParticipante2) {
                  
                  this.nombreParticipante = this.dataValidaciones.Representante.nombre;
                  this.estado = this.dataValidaciones.Estado;
                  
                  this.focus(ref);
                  this.noExiste = true;
                  ////console.log('GRUPOS ', this.dataValidaciones.grupos);
                  if (this.dataValidaciones.grupos !== '') {
                    this.grupos = {
                    name: this.dataValidaciones.grupos.GRUPO,
                    perId: this.dataValidaciones.grupos.PER_ID
                  }
                  }
                 
                } else {
                  alert("Los patrocinantes deben tener rut distinto");
                  
                }
                } else {
                  alert("El patrocinante no existe");
                  this.noExiste = false;
                }
      
              }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });

            } else {
              alert("No puede tener el mismo RUT de un Accionista");
              this.rutParticipante = "";
            }

      } else if (this.rutPartnerGlobal !== '' && this.rutPartnersGlobal.length !== 0) {

          //if (this.rutPartnerGlobal !== '' && this.rutPartnersGlobal.length !== 0) {
          
          for (let i=0; i < this.rutPartnersGlobal[0].length; i++) {
          ////console.log(this.rutPartnersGlobal[0][i].rutPerson);
            if (this.rutPartnersGlobal[0][i].rutPerson !== rut ) {

              axios.get(this.urlBase+'/validatePatrocinantes/' + rut).then((response) => {
                this.dataValidaciones = response.data;
              
                if (Object.keys(this.dataValidaciones).length !== 0) {
                  if (this.rutParticipante !== this.rutParticipante2) {
                  
                  this.nombreParticipante = this.dataValidaciones.Representante.nombre;
                  this.estado = this.dataValidaciones.Estado;
                  this.focus(ref);
                  this.noExiste = true;
                  ////console.log(this.dataValidaciones.grupos);
                  if (this.dataValidaciones.grupos !== '') {
                    this.grupos = {
                    name: this.dataValidaciones.grupos.GRUPO,
                    perId: this.dataValidaciones.grupos.PER_ID
                    }
                  }
                  
                } else {
                  alert("Los patrocinantes deben tener rut distinto");
                  
                }
                } else {
                  alert("El patrocinante no existe");
                  this.noExiste = false;
                }
      
              }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });

            } else {
              alert("No puede tener el mismo RUT de un Accionista");
              this.rutParticipante = "";
            }
        }
      } else {
          alert("Debe completar composición accionaria del paso anterior");
          this.rutParticipante = "";
        }
      },
       */

      /*
        validateRutExist2(rut, ref) {
          
           if (this.rutPartnerGlobal !== '' && this.rutPartnersGlobal.length == 0) {
  
             if (this.rutPartnerGlobal !== rut ) { 
  
              axios.get(this.urlBase+'/validatePatrocinantes/' + rut).then((response) => {
          
                this.dataValidaciones = response.data;
                if (Object.keys(this.dataValidaciones).length !== 0
                ) {
                  if (this.rutParticipante !== this.rutParticipante2) {
                  this.nombreParticipante2 = this.dataValidaciones.Representante.nombre;
                  this.focus(ref);
                  this.estado2 = this.dataValidaciones.Estado;
                  //this.estado = this.dataValidaciones.Estado;
                  this.noExiste = true;
                  this.grupos2 = {
                    name: this.dataValidaciones.grupos.GRUPO,
                    perId: this.dataValidaciones.grupos.PER_ID
                  }
                } else {
                  alert("Los patrocinantes deben tener rut distinto");
                }
                } else {
                  alert("El Patrocinante no existe");
                  this.noExiste = false;
                }
  
              }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });
  
            } else {
              alert("No puede tener el mismo RUT de un Accionista");
              this.rutParticipante2 = "";
            }
  
  
           } else if (this.rutPartnersGlobal.length !== 0 || this.rutPartnerGlobal !== '') {
          
          for (let i=0; i < this.rutPartnersGlobal[0].length; i++) {
  
            if (this.rutPartnersGlobal[0][i].rutPerson !== rut ) { 
  
              axios.get(this.urlBase+'/validatePatrocinantes/' + rut).then((response) => {
          
                this.dataValidaciones = response.data;
                if (Object.keys(this.dataValidaciones).length !== 0
                ) {
                  if (this.rutParticipante !== this.rutParticipante2) {
                  this.nombreParticipante2 = this.dataValidaciones.Representante.nombre;
                  this.focus(ref);
                  this.estado2 = this.dataValidaciones.Estado;
                  this.noExiste = true;
                  this.grupos2 = {
                    name: this.dataValidaciones.grupos.GRUPO,
                    perId: this.dataValidaciones.grupos.PER_ID
                  }
                } else {
                  alert("Los patrocinantes deben tener rut distinto");
                }
                } else {
                  alert("El Patrocinante no existe");
                  this.noExiste = false;
                }
  
              }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });
  
            } else {
              alert("No puede tener el mismo RUT de un Accionista");
              this.rutParticipante2 = "";
            }
          }
  
          } else {
            
            alert("Debe completar composición accionaria del paso anterior");
            this.rutParticipante2 = "";
          
          }
        
        },
       */

       validateRutExist(rut, ref) {
        if (rut !== "") {
          if ((this.rutPartnerGlobal !== '') && (this.rutPartnersGlobal.length === 0)) {
            if (this.rutPartnerGlobal !== rut) {
              const rutString = String(rut);
              
              axios.get(this.urlBase + '/validatePatrocinantes/' + rutString)
                .then((response) => {
                  this.dataValidaciones = response.data;
                  console.log("dataValidaciones", this.dataValidaciones);
            
                  const preRegID = this.dataValidaciones.Representante.PRE_REG_ID;
                  console.log("preRegID...", preRegID);
                  this.estado = this.dataValidaciones.Estado;
                  if (Object.keys(this.dataValidaciones).length !== 0 && this.dataValidaciones.Representante !== "") {
                    if (this.rutParticipante !== this.rutParticipante2) {
                      if (this.dataValidaciones.Representante) {
                        this.idSocioPatrocinante1 = this.dataValidaciones.Representante.PRE_REG_ID;
                        console.log("idSocioPatrocinante1 asignado:", this.idSocioPatrocinante1);
                        console.log("idSocioPatrocinante2 actual:", this.idSocioPatrocinante2);
                        if (this.idSocioPatrocinante1 && this.idSocioPatrocinante2 && 
                          this.idSocioPatrocinante1 == this.idSocioPatrocinante2) {
                          Swal.fire({ 
                            icon: 'warning', 
                            title: 'Estimado postulante, los patrocinadores a ingresar deben estar asociados a distintos N° de socio.'
                          });
                          this.rutParticipante = "";
                          this.nombreParticipante = "";
                          this.idSocioPatrocinante1 = null;
                          return;
                        }
                      }
                      this.nombreParticipante = this.dataValidaciones.Representante.nombre;
                      this.estado = this.dataValidaciones.Estado;
                      this.focus(ref);
                      this.noExiste = true;
                      this.rutNoIdentico = true;

                      if (this.dataValidaciones.grupos) {
                        this.grupos = {
                          name: this.dataValidaciones.grupos.GRUPO,
                          perId: this.dataValidaciones.grupos.PER_ID
                        };
                      }

                      // Llamar a validatePatrocinante1() si el RUT existe
                      this.savePatrocinante1();

                    } else {
                      if (this.rutParticipante !== "" && this.rutParticipante2 !== "") {
                        this.rutNoIdentico = false;
                        Swal.fire({ icon: 'warning', title: 'Los patrocinantes deben tener rut distinto' });
                      }
                      this.rutParticipante = "";
                      this.nombreParticipante = "";
                    }
                  } else if (this.estado == "RUT NO REGISTRADO"){
                    this.noExiste = false;
                    this.rutParticipante = "";
                    this.nombreParticipante = "";
                    this.emailParticipante = "";
                    this.telefonoParticipante = "";
                    Swal.fire({ icon: 'warning', title: 'No existe socio activo asociado al rut' });
                  } else {
                    this.noExiste = false;
                    this.rutParticipante = "";
                    this.nombreParticipante = "";
                    this.emailParticipante = "";
                    this.telefonoParticipante = "";
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` })
                  }
                })
                .catch(error => console.log("AXIOS ERROR: ", error));
            } else {
              Swal.fire({ icon: 'warning', title: 'No puede tener el mismo RUT de un Accionista' });
              this.rutParticipante = "";
            }
          } else if ((this.rutPartnerGlobal !== '') && (this.rutPartnersGlobal.length !== 0)) {
            const arrayPartners = this.rutPartnersGlobal.map(partner => partner.rutPerson);
            const findRut = arrayPartners.indexOf(rut);

            if (findRut === -1) {
              const rutString = String(rut);
              
              axios.get(this.urlBase + '/validatePatrocinantes/' + rutString)
                .then((response) => {

                  this.dataValidaciones = response.data;
                  console.log("dataValidaciones", this.dataValidaciones);
            
                  const preRegID = this.dataValidaciones.Representante.PRE_REG_ID;
                  console.log("preRegID...", preRegID);
                  this.estado = this.dataValidaciones.Estado;

                 if (Object.keys(this.dataValidaciones).length !== 0 && this.dataValidaciones.Representante !== "") {
                    if (this.rutParticipante !== this.rutParticipante2) {
                      if (this.dataValidaciones.Representante) {
                        this.idSocioPatrocinante1 = this.dataValidaciones.Representante.PRE_REG_ID;
                        console.log("idSocioPatrocinante1 asignado:", this.idSocioPatrocinante1);
                        console.log("idSocioPatrocinante2 actual:", this.idSocioPatrocinante2);
                        if (this.idSocioPatrocinante1 && this.idSocioPatrocinante2 && 
                          this.idSocioPatrocinante1 == this.idSocioPatrocinante2) {
                          Swal.fire({ 
                            icon: 'warning', 
                            title: 'Estimado postulante, los patrocinadores a ingresar deben estar asociados a distintos N° de socio.'
                          });
                          this.rutParticipante = "";
                          this.nombreParticipante = "";
                          this.idSocioPatrocinante1 = null;
                          return;
                        }
                      }
                      this.nombreParticipante = this.dataValidaciones.Representante.nombre;
                      this.estado = this.dataValidaciones.Estado;
                      this.focus(ref);
                      this.noExiste = true;
                      this.rutNoIdentico = true;

                      if (this.dataValidaciones.grupos) {
                        this.grupos = {
                          name: this.dataValidaciones.grupos.GRUPO,
                          perId: this.dataValidaciones.grupos.PER_ID
                        };
                      }

                      //Llamar a validatePatrocinante1() si el RUT existe
                      this.savePatrocinante1();

                    } else {
                      if (this.rutParticipante !== "" && this.rutParticipante2 !== "") {
                        this.rutNoIdentico = false;
                        Swal.fire({ icon: 'warning', title: 'Los patrocinantes deben tener rut distinto' });
                      }
                      this.rutParticipante = "";
                      this.nombreParticipante = "";
                    }
                  } else if (this.estado == "RUT NO REGISTRADO"){
                    this.noExiste = false;
                    this.rutParticipante = "";
                    this.nombreParticipante = "";
                    this.emailParticipante = "";
                    this.telefonoParticipante = "";
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` });
                  }else{
                    this.noExiste = false;
                    this.rutParticipante = "";
                    this.nombreParticipante = "";
                    this.emailParticipante = "";
                    this.telefonoParticipante = "";
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` })
                  }
                })
                .catch(error => console.log("AXIOS ERROR: ", error));
            } else {
              Swal.fire({ icon: 'warning', title: 'No puede tener el mismo RUT de un Accionista' });
              this.rutParticipante = "";
              this.nombreParticipante = "";
            }
          } else {
            if (this.showStepThree) {
              Swal.fire({ icon: 'warning', title: 'Debe completar composición accionaria del paso anterior' });
              this.rutParticipante = "";
              this.nombreParticipante = "";
            }
          }
        }
      },

      validateRutExist2(rut, ref) {
        if (rut !== "") {
           if (this.rutPartnerGlobal !== '' && this.rutPartnersGlobal.length == 0) {
             if (this.rutPartnerGlobal !== rut ) { 
              const rutString = new String(rut) 
              axios.get(this.urlBase+'/validatePatrocinantes/' + rutString).then((response) => {
          
                this.dataValidaciones = response.data;
                console.log("dataValidaciones", this.dataValidaciones);
            
                const preRegID2 = this.dataValidaciones.Representante.PRE_REG_ID;
                console.log("preRegID2...", preRegID2);
                if (Object.keys(this.dataValidaciones).length !== 0 && this.dataValidaciones.Representante !== ""
                ) {
                  if (this.rutParticipante !== this.rutParticipante2) {
                    if(this.rutParticipante2 !== "") {
                      if (this.dataValidaciones.Representante) {
                        this.idSocioPatrocinante2 = this.dataValidaciones.Representante.PRE_REG_ID;
                        console.log("idSocioPatrocinante2 asignado:", this.idSocioPatrocinante2);
                        console.log("idSocioPatrocinante1 actual:", this.idSocioPatrocinante1);
                        if (this.idSocioPatrocinante1 && this.idSocioPatrocinante2 && 
                          this.idSocioPatrocinante1 == this.idSocioPatrocinante2) {
                          Swal.fire({ 
                            icon: 'warning', 
                            title: 'Estimado postulante, los patrocinadores a ingresar deben estar asociados a distintos N° de socio.'
                          });
                          this.rutParticipante2 = "";
                          this.nombreParticipante2 = "";
                          this.idSocioPatrocinante2 = null;
                          return;
                        }
                      }
                      this.nombreParticipante2 = this.dataValidaciones.Representante.nombre;
                      this.focus(ref);
                      this.estado2 = this.dataValidaciones.Estado;
                      //this.estado = this.dataValidaciones.Estado;
                      this.noExiste2 = true;
                      this.rutNoIdentico = true;
                       if (this.dataValidaciones.grupos !== '' && this.dataValidaciones.grupos !== 'undefined') {
                         this.grupos2 = {
                           name: this.dataValidaciones.grupos.GRUPO,
                           perId: this.dataValidaciones.grupos.PER_ID
                         }
                       }
                      }
                      this.savePatrocinante2();
                } else {
                  if (this.rutParticipante !== "" && this.rutParticipante2 !== "") {
                    this.rutNoIdentico = false;
                    
                    //this.nombreParticipante2 = "";
                    // alert("Los patrocinantes deben tener rut distinto");
                    Swal.fire({
                            icon: 'warning',
                            title: 'Los patrocinantes deben tener rut distinto',
                          })
  
                  }
                  this.rutParticipante2 = "";
                  this.nombreParticipante2 = "";
                }
                } else {
                  // alert("El Patrocinante no existe");
                      this.noExiste2 = false;
                      this.rutParticipante2 = "";
                      this.nombreParticipante2 = "";
                      this.emailParticipante2 = "";
                      this.telefonoParticipante2 = "";
                      Swal.fire({
                        icon: 'warning',
                        title: 'No existe socio activo asociado al rut',
                      })
                }
  
              }).catch(function (error) {
              //console.log("AXIOS ERROR: ", error);
              });
  
            } else {
              // alert("No puede tener el mismo RUT de un Accionista");
              Swal.fire({
                            icon: 'warning',
                            title: 'No puede tener el mismo RUT de un Accionista',
                          })
              this.rutParticipante2 = "";
            }
  
  
           } else if (this.rutPartnersGlobal.length !== 0 || this.rutPartnerGlobal !== '') {
             const arrayPartners = [];
              
              for (let i=0; i < this.rutPartnersGlobal.length; i++) { 
                //console.log(this.rutPartnersGlobal[i].rutPerson);
                arrayPartners.push(this.rutPartnersGlobal[i].rutPerson)
               }

               //console.log('array',arrayPartners);
               const findRut = arrayPartners.indexOf(rut)
          
            
  
              if (findRut === -1) { 
                const rutString = new String(rut) 
                axios.get(this.urlBase+'/validatePatrocinantes/' + rutString).then((response) => {
            
                  this.dataValidaciones = response.data;
                  console.log("dataValidaciones", this.dataValidaciones);
            
                  const preRegID2 = this.dataValidaciones.Representante.PRE_REG_ID;
                  console.log("preRegID2...", preRegID2);
                  this.estado2 = this.dataValidaciones.Estado;
                  if (Object.keys(this.dataValidaciones).length !== 0 && this.dataValidaciones.Representante !== ""
                  ) {
                    if (this.rutParticipante !== this.rutParticipante2) {
                      if(this.rutParticipante2 !== "") {
                      if (this.dataValidaciones.Representante) {
                        this.idSocioPatrocinante2 = this.dataValidaciones.Representante.PRE_REG_ID;
                        console.log("idSocioPatrocinante2 asignado:", this.idSocioPatrocinante2);
                        console.log("idSocioPatrocinante1 actual:", this.idSocioPatrocinante1);
                        if (this.idSocioPatrocinante1 && this.idSocioPatrocinante2 && 
                          this.idSocioPatrocinante1 == this.idSocioPatrocinante2) {
                          Swal.fire({ 
                            icon: 'warning', 
                            title: 'Estimado postulante, los patrocinadores a ingresar deben estar asociados a distintos N° de socio.'
                          });
                          this.rutParticipante2 = "";
                          this.nombreParticipante2 = "";
                          this.idSocioPatrocinante2 = null;
                          return;
                        }
                      }
                      this.nombreParticipante2 = this.dataValidaciones.Representante.nombre;
                      this.focus(ref);
                      this.estado2 = this.dataValidaciones.Estado;
                      this.noExiste2 = true;
                      this.rutNoIdentico = true;
                      if (this.dataValidaciones.grupos !== '' && this.dataValidaciones.grupos !== 'undefined') {
                        this.grupos2 = {
                          name: this.dataValidaciones.grupos.GRUPO,
                          perId: this.dataValidaciones.grupos.PER_ID
                        }
                      }
                      }
                      this.savePatrocinante2();
                    } else {
                      if (this.rutParticipante !== "" && this.rutParticipante2 !== "") {
                        this.rutNoIdentico = false;
                        // alert("Los patrocinantes deben tener rut distinto");
                        Swal.fire({
                              icon: 'warning',
                              title: 'Los patrocinantes deben tener rut distinto',
                            })
                      }
                        this.rutParticipante2 = "";
                    }
                  } else if (this.estado2 == "RUT NO REGISTRADO"){
                    this.noExiste2 = false;
                    this.rutParticipante2 = "";
                    this.nombreParticipante2 = "";
                    this.emailParticipante2 = "";
                    this.telefonoParticipante2 = "";
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` })
                  }else{
                    this.noExiste2 = false;
                    this.rutParticipante2 = "";
                    this.nombreParticipante2 = "";
                    this.emailParticipante2 = "";
                    this.telefonoParticipante2 = "";
                    Swal.fire({
                      icon: 'warning',
                      width: '800px',
                      html: `
                       <div style="text-align: left;">
                      <strong>Estimado postulante: </strong>
                      El patrocinante ingresado no cumple con los requisitos establecidos para ser patrocinante. A continuación, detallamos los requisitos que deben cumplirse:<br><br>
                      
                      1. <strong>Para el caso de empresas:</strong> Quien patrocina debe ser el representante ante la Cámara o el representante legal de la empresa.<br><br>

                      2. <strong>Relación con el postulante:</strong> El patrocinante no debe tener ninguna relación directa con el postulante.<br><br>

                      3. <strong>Restricciones de parentesco y grupo empresarial:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas naturales, no podrán actuar como patrocinantes quienes sean parientes hasta el segundo grado de consanguinidad (hermanos, hijos, nietos, padres o abuelos).<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ En el caso de postulantes personas jurídicas, no podrán patrocinar quienes pertenezcan al mismo grupo empresarial, conforme a la Ley N° 18.045 sobre Mercado de Valores.<br><br>

                      4. <strong>Restricciones para determinados roles dentro de la Cámara:</strong><br>
                      &nbsp;&nbsp;&nbsp;&nbsp;○ No pueden actuar como patrocinantes:<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de mesas directivas nacionales y de Cámaras regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Directores nacionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Consejeros regionales.<br>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- Integrantes de las Comisiones de Socios a nivel nacional.
                      </div>` })
                  }
    
                }).catch(function (error) {
                //console.log("AXIOS ERROR: ", error);
                });
    
              } else {
                // alert("No puede tener el mismo RUT de un Accionista");
                Swal.fire({
                              icon: 'warning',
                              title: 'No puede tener el mismo RUT de un Accionista',
                            })
                this.rutParticipante2 = "";
            }
          
  
          } else {
            // alert("Debe completar composición accionaria del paso anterior");
            if (this.showStepThree){
              Swal.fire({
                              icon: 'warning',
                              title: 'Debe completar composición accionaria del paso anterior',
                            })
              this.rutParticipante2 = "";
              this.nombreParticipante2 = "";
            }
          }
        }
      
      },


      validateInput() {
        //console.log(this.rutParticipante)
        //console.log(this.nombreParticipante)
        //console.log(this.emailParticipante)
        //console.log(this.telefonoParticipante)
        //console.log(this.rutParticipante2)
        //console.log(this.nombreParticipante2)
        //console.log(this.emailParticipante2)
        //console.log(this.telefonoParticipante2)

        //console.log('rutPatrocinanteIsValid',this.rutPatrocinanteIsValid);
        //console.log('rutPatrocinante2IsValid',this.rutPatrocinante2IsValid);
        //console.log('telPatrocinanteIsValid',this.telPatrocinanteIsValid);
        //console.log('telPatrocinante2IsValid',this.telPatrocinante2IsValid);
        //console.log('emailPatrocinanteIsValid',this.emailPatrocinanteIsValid);
        //console.log('emailPatrocinante2IsValid',this.emailPatrocinante2IsValid);
         
        if (this.rutParticipante !== '' && this.nombreParticipante !== '' && this.emailParticipante !== '' 
            && this.telefonoParticipante !== '' && this.rutParticipante2 !== '' && this.nombreParticipante2 !== ''
            && this.emailParticipante2 !== '' && this.telefonoParticipante2 !== '') {
          if (this.rutPatrocinanteIsValid 
              && this.rutPatrocinante2IsValid 
              && this.telPatrocinanteIsValid 
              && this.telPatrocinante2IsValid 
              && this.emailPatrocinanteIsValid
              && this.emailPatrocinante2IsValid) {
            return true;
          } else {
            //console.log("%cValidation don't found", "color: red;")
            return false;
          }
        } else {
          //console.log("%cInput don't found", "color: red;")
          return false;
        }
      },

      validateInputPatrocinante1() {
        if (this.rutParticipante !== '' && this.nombreParticipante !== '' && this.emailParticipante !== '' 
            && this.telefonoParticipante !== '') {
          if (this.rutPatrocinanteIsValid == true 
              && this.telPatrocinanteIsValid == true 
              && this.emailPatrocinanteIsValid == true) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      validateInputPatrocinante2() {
        if ( this.rutParticipante2 !== '' && this.nombreParticipante2 !== ''
            && this.emailParticipante2 !== '' && this.telefonoParticipante2 !== '') {
              if ( 
                 this.rutPatrocinante2IsValid == true 
              && this.telPatrocinante2IsValid == true 
              && this.emailPatrocinante2IsValid == true ) {
                return true;
              } else {
                return false;
              }
              
            } else {
              return false;
            }
      },

      saveContinue() {
        // //console.log('validateInput',this.validateInput());
        //console.log('identico???',this.rutNoIdentico);
        //console.log('rut2',this.rutParticipante2);
        // this.validateRutExist(this.rutParticipante, this.$refs.nombre)
        // this.validateRutExist2(this.rutParticipante2, this.$refs.nombre2)
        if (this.findAccionistas()) {
            if ((this.rutParticipante !== this.rutParticipante2) && (this.rutParticipante !== "") && (this.rutParticipante2 !== "")) {
              //console.log('NoExiste',this.noExiste);
              //console.log('NoExiste',this.noExiste2);
            if (this.validateInput() && this.noExiste && this.noExiste2) {
              this.saveContinueStepThree();
              //this.save();
    
              if (this.cumple && this.cumple2) {
    
                // this.rutPatrocinatnes.push({rut1: this.rutParticipante, rut2: this.rutParticipante2});
                this.rutPatrocinatnes[0] = {rut1: this.rutParticipante, rut2: this.rutParticipante2};
                
                this.rutPatrocinates(this.rutPatrocinatnes);  
                this.setStepFourValue(true);
                this.setStepThreeValue(false);
              } 
              
            } else {
              // alert("Debe completar todos los campos");
              Swal.fire({
                            icon: 'warning',
                            title: 'Debe completar todos los campos',
                          })
              this.setStepFourValue(false);
            }

          } else {
            // alert('Los patrocinantes deben tener rut distinto')
            if (!(this.validateInput()) || !(this.noExiste) || !(this.noExiste2)) {
              Swal.fire({
                            icon: 'warning',
                            title: 'Debe completar todos los campos',
                          })
            }
          }
        } 
        
      },

    findAccionistas() {
       if ((this.rutPartnerGlobal !== '') && (this.rutPartnersGlobal.length === 0)) {
          //console.log('FIND ACCIONISTA PRIMERA');
         if ((this.rutParticipante !== "") && (this.rutParticipante2 !== "")){
            
           if ((this.rutParticipante === this.rutPartnerGlobal)) {
             Swal.fire({
               icon: 'warning',
               title: 'El patrocinante 1 no puede tener el mismo rut que un accionista',
             })
             return false;
           } else if((this.rutParticipante2 === this.rutPartnerGlobal)) {
             Swal.fire({
               icon: 'warning',
               title: 'El patrocinante 2 no puede tener el mismo rut que un accionista',
             })
             return false;
           } else {
             return true
           }     
           
             Swal.fire({
               icon: 'warning',
               title: 'Los patrocinantes deben tener rut distinto',
             })
         } else {
            Swal.fire({
                               icon: 'warning',
                               title: 'Debe completar todos los campos',
                             })
         }

       } else  if ((this.rutPartnerGlobal !== '') && (this.rutPartnersGlobal.length !== 0)){
         //console.log('FIND ACCIONISTA SEGUNDA');
         const arrayPartners = [];
         for (let i=0; i < this.rutPartnersGlobal[0].length; i++) { 
           //console.log(this.rutPartnersGlobal[0][i].rutPerson);
           arrayPartners.push(this.rutPartnersGlobal[0][i].rutPerson)
         }
         //console.log('array',arrayPartners);
         if ((this.rutParticipante !== "") && (this.rutParticipante2 !== "")){
           const findRut = arrayPartners.indexOf(this.rutParticipante)        
           const findRut2 = arrayPartners.indexOf(this.rutParticipante2)  
           if ((findRut >= 0)) {
             Swal.fire({
               icon: 'warning',
               title: 'El patrocinante 1 no puede tener el mismo rut que un accionista',
             })
             return false;
           } else if((findRut2 >= 0)) {
             Swal.fire({
               icon: 'warning',
               title: 'El patrocinante 2 no puede tener el mismo rut que un accionista',
             })
             return false;
           } else {
             return true
           }     
           
            //  Swal.fire({
            //    icon: 'warning',
            //    title: 'Los patrocinantes deben tener rut distinto',
            //  })
         } else {
            Swal.fire({
                               icon: 'warning',
                               title: 'Debe completar todos los campos',
                             })
         }
       }
       
              
    },

    anterior() {
        //this.$router.push({ name: "StepTwo" });
        this.setStepTwoValue(true);
        this.setStepThreeValue(false);
    },

    siguiente(){
        this.setStepFourValue(true);
        this.setStepThreeValue(false);
    },
    
    savePostStepThree: function () {
     
      let objPatrocinante = this.completedForm;
      let data = JSON.stringify(objPatrocinante);
     
      //console.log("Step three Object ready to be sent: " + data);
      //console.log("objPatrocinante length: " + objPatrocinante.length);
      if (this.completedForm.length > 0) {
        axios.post(this.urlBase + '/guardarParcial', data).then((response) => {
        //console.log(response.data);
        }).catch(function (error) {
        //console.log("AXIOS ERROR: ", error);
        });
      } else {
          // alert("¡Error al guardar, intente de nuevo!");
          Swal.fire({
                icon: 'warning',
                title: '¡Error al guardar, intente de nuevo!',
            })
        }
    },

      show () {
            this.$modal.show('help-modal-1');
      },

      hide () {
            this.$modal.hide('help-modal-1');
      },
      companyRutValidation (rut) {
      let rutCompany = rut;
      //console.log('llego',rutCompany);
      axios.get(this.urlBase + '/rutEmpresa/' + rutCompany).then((response) => {
        let rutEmpresa = response.data;
        this.rutCompanyValidation = rutEmpresa;
        ////console.log(this.rutCompanyValidation);
        ////console.log(this.rutCompanyValidation[0]);
        if (this.rutCompanyValidation.length > 0) {
          //alert("Rut ingresado no corresponde a rut de empresa");
          Swal.fire({
                icon: 'warning',
                title: 'Rut ingresado no corresponde a rut de empresa',
            })
          
          this.setRutIsValid(false);
        } else {
          ////console.log('se cargo rut');
          this.getRutGlobal(rutCompany);
        }
        ////console.log(this.tipoSocDocs);
      }).catch(function (error) {
        //console.log("AXIOS ERROR: ", error);
      });
    },

       // traemos el objeto de nuevo
      getRut() {
      let routeNumber = this.$route.params.id;
      let number;
      let rut;
      axios.get(this.URL + '/getRut/' + routeNumber).then((response) => {
        let data = response.data;
        number = data[0].requestNumber;
        rut = data[0].rut;
        if (routeNumber == number) {
          //console.log("Match requestNumber");
          // this.rutCompany = rut;
          // this.companyRutValidation(rut);
          this.getNroSolicitud(rut);
        } else {
        }
      }).catch(function (error) {
        //console.log("AXIOS ERROR: ", error);
      });
    },
    getNroSolicitud(rut) {
      axios.get(this.urlBase+'/buscarPostulante/' + rut).then((response) => {
        const datosBasicos = response.data;
        const nroSolicitud = datosBasicos[0].nro_solicitud;
        this.validationStep(nroSolicitud);
      setTimeout(this.getStepThreeRequest(nroSolicitud), 3000);
      }).catch(function (error) {
      //console.log("AXIOS ERROR: ", error);
      });
    },

    // metodo que verifica la correccion del formulario
		validationStep(nroSolicitud){
				//console.log('Numero de SOLICITUD', nroSolicitud)
			
			axios.get(this.URL + '/validarCorreccion/' + nroSolicitud +'-3').then((response) => {
				let data = response.data;
				//console.log('Response Validar Correccion',data);
				
				if (data.ESTADO !== 'PENDIENTE A ENVÍO') {
					//CORREGIR_PASO viene true si se debe volver a ingresar informacion y false si no se debe corregir, es decir es valido
					this.corregir = data.CORREGIR_PASO;
					this.tieneCorreccion = true; // indica que tomara el camino de correccion
          console.log("tiene correccion", tieneCorreccion);
				}
		        
		      }).catch(function (error) {
		        //console.log("AXIOS ERROR: ", error);
		      });
      },
      
     getStepThreeRequest (number) {
      
      //console.log('number',number)
      let requestNumber = number;
      axios.get(this.urlBase + '/paso1/' + requestNumber).then((response) => {
        let stepOneSaved = response.data;
        this.formLoaded = true;
        if(stepOneSaved.length){
          if (stepOneSaved[0].object !== '') {
            this.getStepThree = JSON.parse(stepOneSaved[0].object);

            const estado = JSON.parse(stepOneSaved[0].estado);
            // //console.log('ESTADOOOOOOOO',estado);
            const idConecta = JSON.parse(stepOneSaved[0].idConecta); // nueva modificacion al back
            if ((estado === 1 && idConecta == null) || estado === 3) {
          
              //this.$store.commit('setObjectData',this.getStepOne);
    
    
              //console.log('objeto rescatado en el paso 3', this.getStepThree)
              //this.recoveryDataForm(this.getStepThree);
    
              // TRAEMOS LA VARIABLE GLOBAL CON EL OBJETO ALMACENADO
              this.storeObjectStepThree = this.$store.getters.getterObjetoStepThree;
              // //console.log('STORE// objetoStepThree: '+ this.storeObjectStepThree);
              if(this.storeObjectStepThree.length == 1) {
                // this.$store.commit('setObjetoStepThree',this.getStepThree);
                this.recoveryDataForm(this.getStepThree);
              } else {
                this.recoveryDataForm(this.storeObjectStepThree);
              }
              
            } 
            if (estado === 2 || estado === 0) {
              // SE PODRIA EMPLEAR PARA REDIRECCION A HOME
              //console.log('Estado de solicitud Caducada o Inactiva');
            }
          } else {
            this.setAuth(false);
          }
        }
      }).catch(function (error) {
        //console.log("AXIOS ERROR: ", error);
      });
    },

      recoveryDataForm(objectData) {
        const patrocinantes = []
        //const stepThree = this.$store.getters.getterObjectData[3]
        const stepThree =  objectData[3]
        if (stepThree) {
          //console.log('datitos',stepThree);
          this.findPatrocinantes(stepThree);
        } else {
          //console.log('No existe recuperacion parcial para StepThree');
        }
        

      },
      findPatrocinantes(patrocinantes){
        
				if(patrocinantes.length > 0) {
          if(patrocinantes[0] != null){
					  const patrocinante1 = patrocinantes[0].patrocinante1;
            this.recoveryDataPatrocinante1(patrocinante1);
          }
          if(patrocinantes[1] != null){
					  const patrocinante2 = patrocinantes[1].patrocinante2;
            this.recoveryDataPatrocinante2(patrocinante2)
          }
				} 
			},

    recoveryDataPatrocinante1 ( patrocinante1) {
      //console.log('dentro de patrocinante 1',patrocinante1);

			if (patrocinante1) {
			//inicio de carga patrocinante 1
			if ( patrocinante1.rutParticipante ) {
				this.$refs.rut.className = 'input active';
        this.$refs.rutParticipante.value = patrocinante1.rutParticipante;
				this.rutParticipante = patrocinante1.rutParticipante;
				// this.$store.commit('rutPatrocinanteValidation',this.rutParticipante);
				// this.validateRutExist(this.rutParticipante,this.$refs.nombre )
			}
			if ( patrocinante1.nombreParticipante ) {
        this.$refs.nombre.className = 'input active';
        this.$refs.nombreParticipante.value = patrocinante1.nombreParticipante;
				this.nombreParticipante = patrocinante1.nombreParticipante;
			}
			if ( patrocinante1.telefonoParticipante ) {
				//this.$refs.telefono.className = 'input active';
				this.telefonoParticipante = patrocinante1.telefonoParticipante;
				this.$store.commit('telPatrocinanteValidation', this.telefonoParticipante)
				}
			if ( patrocinante1.emailParticipante ) {
				this.$refs.email.className = 'input active';
				this.emailParticipante = patrocinante1.emailParticipante;
				this.$store.commit('emailPatrocinanteValidation', this.emailParticipante)
			}
			// validacion rut patrocinante 1

			if(this.$refs.rut ) {
				this.$store.commit('rutPatrocinanteValidation',this.rutParticipante);
				//this.validateRutExist(this.rutParticipante,this.$refs.rut )
				this.validateRutExist(this.rutParticipante,this.$refs.nombre )
				}
			} else {
			//console.log('no existe participante 1');
			}
		 
		 
		},
		recoveryDataPatrocinante2 ( patrocinante2) {
      
      //console.log('dentro de patrocinante 2',patrocinante2);
        
			if (patrocinante2) {
			//inicio de carga patrocinante 2
			if ( patrocinante2.rutParticipante ) {
				this.$refs.rut2.className = 'input active';
				this.$refs.rutParticipante2.value = patrocinante2.rutParticipante;
				this.rutParticipante2 = patrocinante2.rutParticipante;
			}
			//console.log('se seteara este nombre ',patrocinante2.nombreParticipante );
			if ( patrocinante2.nombreParticipante ) {
        this.$refs.nombre2.className = 'input active';
				this.$refs.nombreParticipante2.value = patrocinante2.nombreParticipante;
				this.nombreParticipante2 = patrocinante2.nombreParticipante;
			}
				if ( patrocinante2.telefonoParticipante ) {
				this.$refs.telefono2.className = 'input active';
				this.telefonoParticipante2 = patrocinante2.telefonoParticipante;
				this.$store.commit('telPatrocinante2Validation', this.telefonoParticipante2)
				}
				if ( patrocinante2.emailParticipante ) {
					this.$refs.email2.className = 'input active';
					this.emailParticipante2 = patrocinante2.emailParticipante;
					this.$store.commit('emailPatrocinante2Validation', this.emailParticipante2)
				}
				
				// Validacion Rut Patrocinante 2
				if(this.$refs.rut2 ) {
				this.$store.commit('rutPatrocinante2Validation',this.rutParticipante2);
				//this.validateRutExist2(this.rutParticipante2,this.$refs.rut2 );
				this.validateRutExist2(this.rutParticipante2,this.$refs.nombre2 );
				} 
				
			} else {
				//console.log('no existe participante 2');
			}    
			
			
    },

    scrollToTop() {
      window.scrollTo(0,0);
    },

    
    },
    computed: {
      ...mapState(['collapse', 
                  'telIsValid', 
                  'emailIsValid',
                  'rutIsValid',
                  'completedForm', 
                  'rutGlobal', 
                  'rutPartnersGlobal',
                  'rutPartnerGlobal',
                  'rutPatrocinanteIsValid',
                  'rutPatrocinante2IsValid',
                  'telPatrocinanteIsValid',
                  'telPatrocinante2IsValid',
                  'emailPatrocinanteIsValid',
                  'emailPatrocinante2IsValid',
                  'URL',
                  'globalRequestNumber',
                  'nroSolicitudGlobal',
                  'showStepThree'
                  ]),
      // rutPartnerGlobalChange: function () {
      //      return this.rutPartnerGlobal;
      //   }
    },
    

    created () {
      this.getRut();
      // //console.log(this.completedForm);
      // //console.log(this.nroSolicitudGlobal);
      //this.chargeObjectData()
      // //console.log('PASO 3 HABILITADO',this.showStepThree)
    },
    
    
}
</script>


<style>
  .vm--modal {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    background-color: white;
    border-radius: 3px;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    background: #185bc1;
    color: #fff;
    padding: 30px;
}
  *:disabled {
		color: #ccc;
    	border-color: #ccc;
	}	

	i{
		z-index: 25;
	}
	label{
		z-index: 25;
	}	
	
	select:disabled {
    	opacity: 0.3;
	}

 .vm--modal .close-modal-text {
    cursor: pointer;
    position: absolute;
    font-size: 20px;
    top: 10px;
    right: 20px;
    color: #fff;
}

*:focus {
  outline: white;
}

button:disabled,
button[disabled]{
  border: 1px solid #999999 !important;
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed;
}
</style>

